export default "__VITE_ASSET__C_eC_D4k__"